/**
 * A typed notification without retained state, for moments other objects react to: the organization changed,
 * the session expired.
 */
export class Signal<Value = void> {
	#listeners = new Set<(value: Value) => void>();

	/**
	 * @returns The function that ends the subscription
	 */
	on(listener: (value: Value) => void) {
		this.#listeners.add(listener);
		return () => void this.#listeners.delete(listener);
	}

	emit(value: Value) {
		for (const listener of [...this.#listeners]) listener(value);
	}
}
